import React, { useCallback } from 'react'
import Dropdown from '@sl/ui-library/organisms/Dropdown'

const SelectValues = [
  {
    label: "Moins d'un mois",
    value: '3',
  },
  {
    label: 'Entre un et deux mois ',
    value: '2',
  },
  {
    label: 'Plus de deux mois',
    value: '1',
  },
  {
    label: 'Aucune idée',
    value: '4',
  },
]

const checkDate = val => val.value !== null

const MoveDateInput = ({ state, setState }) => {
  const { value } = state.moveDate
  const handleChangeMoveDate = useCallback(e => {
    setState(prev => ({
      ...prev,
      moveDate: {
        ...prev.moveDate,
        value: SelectValues.find(i => i.value === e),
        valid: checkDate(e),
      },
    }))
  }, [])
  const content = (
    <>
      <Dropdown
        values={SelectValues}
        maxDisplay={3}
        id="MooveFormLandingMoveDateInput"
        style={{ width: '100%' }}
        value={value.value}
        onChange={handleChangeMoveDate}
        defaultLabel="Date du déménagement"
      />
    </>
  )

  return content
}

export default MoveDateInput
